<li><a href="#" onclick="aumentarTamanhoFonte();return false;" id="btnAumentar"><i class="fa fa-plus-square"></i>&nbsp;AUMENTAR FONTE</a></li>
<li><a href="#" onclick="diminuirTamanhoFonte();return false;" id="btnDiminuir"><i class="fa fa-minus-square"></i>&nbsp;DIMINUIR FONTE</a></li>
